/**
 * `map` — the walk, drawn by whichever renderer this browser can run.
 *
 * There are TWO of them and neither is a fallback for the other in the ordinary
 * sense: `MapSketch` is an SVG over an equirectangular projection that needs no
 * tiles, no key and no third-party host, and `MapLive` is 2GIS MapGL with the
 * museum's own streets under the same pins. `useMapCapability()` is the single
 * authority on which one runs (design §1.3), and its decision is one-way — a
 * map that lost its WebGL context does not come back mid-session, because
 * flickering between two pictures of one walk is worse than committing to the
 * one that always works.
 *
 * `registry.ts` is untouched: the catalogue still says `MapCard`, and the split
 * is a fact about this file.
 */

import type { MapCardProps } from '../generated/schemas';
import { useMapCapability } from '../../map/capability';
import MapLive from './MapLive';
import MapSketch from './MapSketch';

export default function MapCard({ props }: { props: MapCardProps }) {
  const capability = useMapCapability();
  // `pending` draws the live card: its container is already the board's sunken
  // grey, so the frame before the tiles arrive is a well rather than a picture
  // that is about to be replaced by a different one.
  if (capability === 'sketch') return <MapSketch props={props} />;
  return <MapLive props={props} />;
}
